import http from './axios'
import Vue from 'vue'
// 使用配置文件设置生产环境请求地址
function  getBaseUrl(){
  return process.env.NODE_ENV === "development"?process.env.API_ROOT:Vue.prototype.BASE_URL
}
let httpConfig = {
  // 首页数据
    getHome: () => {
      return http.request({
        url: '/api/v1.0/home/find',
        method: 'post',
        data: {},
        // 使用配置文件设置生产环境请求地址
        baseURL: getBaseUrl()
      })
    },
    // 产品功能
    getProduct: () => {
      return http.request({
        url: '/api/v1.0/product/find',
        method: 'post',
        data: {},
        baseURL: getBaseUrl()
      })
    },
    // 解决方案
    getsolution: ()=>{
      return http.request({
        url: '/api/v1.0/solution/find',
        method: 'post',
        data: {},
        baseURL: getBaseUrl()
      })
    },
    // 发展历程 资质荣誉  联系我们
    getAbout: ()=>{
      return http.request({
        url: '/api/v1.0/aboutus/find',
        method: 'post',
        data: {},
        baseURL: getBaseUrl()
      })
    },
    // 新闻查询
    getNews: (params)=>{
      return http.request({
        url: `/api/v1.0/aboutus/news/find?access_token=${localStorage.getItem('token')}`,
        method: 'post',
        data: params,
        baseURL: getBaseUrl()
      })
    },
    getNewsFind: (data)=>{
      return http.request({
        url: `/api/v1.0/aboutus/news/find_one`,
        method: 'post',
        data: data,
        baseURL: getBaseUrl()
      })
    },
    
    // 加入我们
    getRecruit: ()=>{
      return http.request({
        url: '/api/v1.0/aboutus/recruit/find',
        method: 'post',
        data: {},
        baseURL: getBaseUrl()
      })
    },
    // 客户案例
    getCase: ()=>{
      return http.request({
        url: '/api/v1.0/case/find',
        method: 'post',
        data: {},
        baseURL: getBaseUrl()
      })
    },

    // 获取token
    getToken(){
      return http.request({
        url: '/oauth/token',
        method: 'post',
        data: {},
        baseURL: getBaseUrl()
      })
    },

    // 获取header和footer数据
    commonFind(){
      return http.request({
        url: '/api/v1.0/common/find',
        method: 'post',
        data: {},
        baseURL: getBaseUrl()
      })
    },
 
    // 存储试用数据
    createTrial(params){
      return http.request({
        url: `/api/v1.0/trial/add?access_token=${localStorage.getItem('token')}`,
        method: 'post',
        data: params,
        baseURL: getBaseUrl()
      })
    },
  }
export default httpConfig


// WEBPACK FOOTER //
// ./src/api.js